import { PrintFullPage } from './PrintFullPage';
export default PrintFullPage;